import * as React from "react";

import { navComplete } from "@origin-digital/event-dispatcher";

import { ISuccessProps, Success } from "src/components/Success";

import content from "./content.json";

type IProps = Pick<ISuccessProps, "text" | "navComplete">;
const SuccessScreen = (props: IProps) => <Success {...content} {...props} />;

export const UpdateLandlineSuccessScreen: React.FC = () => (
  <SuccessScreen
    text={content.text.landline.update}
    navComplete={navComplete.profileLandline}
  />
);

export const UpdateHomePhoneSuccessScreen: React.FC = () => (
  <SuccessScreen
    text={content.text.homephone.update}
    navComplete={navComplete.profileLandline}
  />
);

export const LandlineSuccessRemoveScreen: React.FC = () => (
  <SuccessScreen
    text={content.text.landline.remove}
    navComplete={navComplete.profileLandline}
  />
);

export const UpdateMobileSuccessScreen: React.FC = () => (
  <SuccessScreen
    text={content.text.mobile.update}
    navComplete={navComplete.profileMobile}
  />
);
